import { KYMW1103Model } from './../kymw1103.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonUploadServiceSub } from 'src/app/commons/kymw00/pless-json-upload-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * csvアップロードAPI用クラス
 *
 * @export GetEBaseDataService
 * @class GetEBaseDataService
 * @extends {PlessUploadServiceSub}
 */
@Injectable()
export class GetEBaseDataService extends PlessJsonUploadServiceSub<any> {
  // 処理に使用するModel
  private model: KYMW1103Model;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetEBaseDataService
   */
  private getBody(): PlessRequest {
    return new PlessRequest();
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetEBaseDataService
   */
  execute(model: KYMW1103Model, file: File, successFunc: Function = null): void {
    this.model = model;
    this.successFunc = successFunc;
    this.sendFile('geteBaseData', this.getBody(), file);
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetEBaseDataService
   */
  success(data: any): void {
    this.model.setEbaseData(data);
    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }
}
